import React, { useMemo } from "react";
import { View } from "react-native";
var AspectRatioViewResizeDirection;
(function (AspectRatioViewResizeDirection) {
    AspectRatioViewResizeDirection["VERTICAL"] = "VERTICAL";
    AspectRatioViewResizeDirection["HORIZONTAL"] = "HORIZONTAL";
})(AspectRatioViewResizeDirection || (AspectRatioViewResizeDirection = {}));
const AspectRatioView = ({ aspectRatio = 1, resizeDirection = AspectRatioViewResizeDirection.HORIZONTAL, multiplier = 1, style: customStyle = {}, children, }) => {
    const combinedStyle = useMemo(() => {
        const isHorizontal = resizeDirection === AspectRatioViewResizeDirection.HORIZONTAL;
        return [
            {
                aspectRatio: isHorizontal ? 1 / (aspectRatio * multiplier) : aspectRatio * multiplier,
                width: isHorizontal ? "100%" : undefined,
                height: !isHorizontal ? "100%" : undefined,
            },
            customStyle,
        ];
    }, [aspectRatio, multiplier, resizeDirection, customStyle]);
    return React.createElement(View, { style: combinedStyle }, children);
};
export { AspectRatioView, AspectRatioViewResizeDirection };
